import EffectiveStrategiesToTurningHappyCustomersIntoBrandAdvocates from "../../assets/images/e-books/Effective-Strategies-to-turning-happy-customers-into-brand-advocates.webp";
import ReigniteCustomerLoveLimitedTimeOffersThatWork from "../../assets/images/e-books/Reignite-Customer-Love-Limited-Time-Offers-That-Work.webp";
import FeedbackMagicAwakeningHibernatingCustomersForGrowth from "../../assets/images/e-books/Feedback-Magic-Awakening-Hibernating-Customers-for-Growth.webp";
import RevitalizeYourCustomerBaseTacticsForOnboardingAndReEngagement from "../../assets/images/e-books/Revitalize-Your-Customer-Base-Tactics-for-Onboarding-and-Re-Engagement.webp";
import AComprehensiveGuideToWinBackYourOnceLoyalCustomers from "../../assets/images/e-books/A-Comprehensive-Guide-to-Win-Back-Your-Once-Loyal-Customers.webp";
import ProvenPersonalizationTacticsToGrabYourCustomersAttention from "../../assets/images/e-books/Proven-Personalization-Tactics-to-Grab-Your-Customers-Attention.webp";
import SecuringLoyaltyStrategiesToKeepYourLoyalCustomersComingBackForMore from "../../assets/images/e-books/Securing-Loyalty-Strategies-to-Keep-Your-Loyal-Customers-Coming-Back-for-More.webp";

import EffectiveStrategiesToTurningHappyCustomersIntoBrandAdvocatesPdfFile from "../../assets/images/e-books/pdf/7 nurturers.pdf";
import ReigniteCustomerLoveLimitedTimeOffersThatWorkPdfFile from "../../assets/images/e-books/pdf/1 one & done.pdf";
import FeedbackMagicAwakeningHibernatingCustomersForGrowthPdfFile from "../../assets/images/e-books/pdf/2 hibernating.pdf";
import RevitalizeYourCustomerBaseTacticsForOnboardingAndReEngagementPdfFile from "../../assets/images/e-books/pdf/3 about to sleep.pdf";

import AComprehensiveGuideToWinBackYourOnceLoyalCustomersPdfFile from "../../assets/images/e-books/pdf/4 good but gone.pdf";
import ProvenPersonalizationTacticsToGrabYourCustomersAttentionPdfFile from "../../assets/images/e-books/pdf/5 never sticky.pdf";
import SecuringLoyaltyStrategiesToKeepYourLoyalCustomersComingBackForMorePdfFile from "../../assets/images/e-books/pdf/6 loyalist.pdf";
// import CDPEbookCoverPicNewPdfFile from "../../assets/images/e-books/pdf/CDP-ebook-cover-Pic-New.pdf";
// Import ebook images as needed (add images to src/assets/images/ebooks/)
// import ebookImage1 from "../../assets/images/ebooks/ebook1.webp";

export const ebooks = [
  {
    id: 1,
    title:
      "Effective Strategies to turning happy customers into brand advocates",
    slug: "revitalize-your-customer-base-tactics-for-onboarding-and-re-engagement",
    excerpt: "",
    image: EffectiveStrategiesToTurningHappyCustomersIntoBrandAdvocates,
    details: [""],
    pdfFile:
      EffectiveStrategiesToTurningHappyCustomersIntoBrandAdvocatesPdfFile,
  },
  {
    id: 2,
    title: "Reignite Customer Love: Limited-Time Offers That Work",
    slug: "reignite-customer-love-limited-time-offers-that-work",
    excerpt: "",
    image: ReigniteCustomerLoveLimitedTimeOffersThatWork,
    details: [""],
    pdfFile: ReigniteCustomerLoveLimitedTimeOffersThatWorkPdfFile,
  },
  {
    id: 3,
    title: "Feedback Magic: Awakening Hibernating Customers for Growth",
    slug: "feedback-magic-awakening-hibernating-customers-for-growth",
    excerpt: "",
    image: FeedbackMagicAwakeningHibernatingCustomersForGrowth,
    details: [""],
    pdfFile: FeedbackMagicAwakeningHibernatingCustomersForGrowthPdfFile,
  },
  {
    id: 4,
    title:
      "Revitalize Your Customer Base: Tactics for Onboarding and Re-Engagement",
    slug: "revitalize-your-customer-base-tactics-for-onboarding-and-re-engagement",
    excerpt: "",
    image: RevitalizeYourCustomerBaseTacticsForOnboardingAndReEngagement,
    details: [""],
    pdfFile:
      RevitalizeYourCustomerBaseTacticsForOnboardingAndReEngagementPdfFile,
  },
  {
    id: 5,
    title: "A Comprehensive Guide to Win Back Your Once Loyal Customers",
    slug: "a-comprehensive-guide-to-win-back-your-once-loyal-customers",
    excerpt: "",
    image: AComprehensiveGuideToWinBackYourOnceLoyalCustomers,
    details: [""],
    pdfFile: AComprehensiveGuideToWinBackYourOnceLoyalCustomersPdfFile,
  },
  {
    id: 6,
    title: "Proven Personalization Tactics to Grab Your Customer’s Attention",
    slug: "proven-personalization-tactics-to-grab-your-customers-attention",
    excerpt: "",
    image: ProvenPersonalizationTacticsToGrabYourCustomersAttention,
    details: [""],
    pdfFile: ProvenPersonalizationTacticsToGrabYourCustomersAttentionPdfFile,
  },
  {
    id: 7,
    title:
      "Securing Loyalty: Strategies to Keep Your Loyal Customers Coming Back for More",
    slug: "securing-loyalty-strategies-to-keep-your-loyal-customers-coming-back-for-more",
    excerpt: "",
    image: SecuringLoyaltyStrategiesToKeepYourLoyalCustomersComingBackForMore,
    details: [""],
    pdfFile:
      SecuringLoyaltyStrategiesToKeepYourLoyalCustomersComingBackForMorePdfFile,
  },
  // {
  //   id: 7,
  //   title: "CDP",
  //   slug: "cdp-ebook",
  //   excerpt: "",
  //   image: CDPEbookCoverPicNew,
  //   details: [""],
  //   pdfFile: CDPEbookCoverPicNewPdfFile,
  // },
];
